import {
  get,
  put,
  post,
  del,
  default as com
} from '@/common/api'

let api = {
  queryOpLog: (para) => {
    return get('/api/op/log', para)
  }
}
export default api
